import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Reveal from "../components/Reveal";
import { projects, projectFilters } from "../mock/data";

const Work = () => {
  const [active, setActive] = useState("All Projects");
  const filtered = active === "All Projects" ? projects : projects.filter((p) => p.category === active);

  return (
    <main>
      {/* HERO */}
      <section className="relative overflow-hidden" style={{ paddingTop: 160, paddingBottom: 56 }}>
        <div className="glow-orb" style={{ width: 380, height: 380, background: "var(--oo-orange)", top: "-10%", left: "-6%", opacity: 0.18 }} />
        <div className="absolute inset-0 grid-overlay" style={{ opacity: 0.35 }} />
        <div className="oo-container relative">
          <Reveal><span className="oo-eyebrow">Our Work</span></Reveal>
          <Reveal delay={80}>
            <h1 className="font-display font-extrabold" style={{ fontSize: "clamp(38px,6vw,76px)", lineHeight: 1.03, marginTop: 20, letterSpacing: "-0.02em", maxWidth: 900 }}>
              From Concept <span className="text-accent">to City Scale</span>
            </h1>
          </Reveal>
        </div>
      </section>

      {/* FILTERS */}
      <section>
        <div className="oo-container">
          <div className="flex flex-wrap gap-3">
            {projectFilters.map((f) => (
              <button
                key={f}
                onClick={() => setActive(f)}
                className="font-display"
                style={{
                  fontSize: 14,
                  fontWeight: 600,
                  padding: "10px 22px",
                  borderRadius: 999,
                  cursor: "pointer",
                  border: "1px solid " + (active === f ? "var(--oo-orange)" : "var(--oo-border)"),
                  background: active === f ? "var(--oo-orange)" : "transparent",
                  color: active === f ? "#fff" : "var(--oo-muted)",
                  transition: "all 0.25s ease",
                }}
              >
                {f === "OOH" ? "OOH Campaigns" : f}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* GRID */}
      <section className="oo-section" style={{ paddingTop: 44 }}>
        <div className="oo-container">
          <div className="grid gap-6 md:grid-cols-2">
            {filtered.map((p, i) => (
              <Reveal key={p.id} delay={(i % 2) * 80}>
                <div className="oo-card block h-full overflow-hidden" style={{ padding: 0 }}>
                  <div style={{ overflow: "hidden", aspectRatio: "16/10" }}>
                    <img src={p.image} alt={p.title} className="w-full h-full object-cover" style={{ transition: "transform 0.6s ease" }}
                      onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.06)")}
                      onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
                    />
                  </div>
                  <div style={{ padding: 30 }}>
                    <span className="oo-eyebrow">{p.tag}</span>
                    <h3 className="font-display" style={{ fontSize: 24, fontWeight: 700, marginTop: 12 }}>{p.title}</h3>
                    <p style={{ color: "var(--oo-muted)", lineHeight: 1.7, marginTop: 12, fontSize: 15 }}>{p.desc}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section style={{ paddingBottom: 110 }}>
        <div className="oo-container text-center">
          <Reveal>
            <h2 className="font-display font-extrabold" style={{ fontSize: "clamp(30px,4.5vw,52px)", letterSpacing: "-0.02em" }}>
              Let's Build Your <span className="text-accent">Next Campaign</span>
            </h2>
            <Link to="/contact" className="btn-primary" style={{ marginTop: 30 }}>
              Get in Touch <ArrowUpRight size={18} />
            </Link>
          </Reveal>
        </div>
      </section>
    </main>
  );
};

export default Work;
